import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124.171 21.34-.029 18.521.003 16",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M11.99 12.185c-1.003 1.162-1.323 2.888-1.323 4.815 0 3.498 2.388 6.333 5.333 6.333s5.333-2.835 5.333-6.333c0-1.927-.32-3.653-1.323-4.815 2.386 1.097 3.99 3.14 3.99 5.482C24 21.164 20.418 24 16 24s-8-2.835-8-6.333c0-2.341 1.604-4.385 3.99-5.482",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M17.3 24.746c-.082.279-.244.808.403.808.471 0 .97-.286 1.456-.034 1.06.55 1.86.157 2.508-.58 0 0-.479.104-.971.082 0 0 .369-.318.404-.736-.323.245-.647.281-.97.281-.324 0-.53-.198-.954-.265.024-.148.05-.3.087-.507.042-.227-.02-.412-.346-.45-.71-.085-1.4.33-2.656.35-1.266-.02-2.134-.435-2.844-.35-.327.039-.389.223-.347.45.038.208.063.359.087.507-.423.067-.63.265-.953.265-.324 0-.648-.036-.971-.281.035.418.404.736.404.736-.492.022-.97-.081-.97-.081.647.736 1.447 1.129 2.507.579.485-.252.985.034 1.456.034.647 0 .485-.53.404-.808q.551.113 1.219.114a5.4 5.4 0 0 0 1.046-.114",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M15.667 8.09v-.757a.333.333 0 0 1 0-.666v-.334a.333.333 0 0 1 .667 0v.334a.333.333 0 0 1 0 .666v.756a.67.67 0 0 1 .332.604c1.522.124 2.668.662 2.668 1.307 0 .395-.43 1.52-1.114 2.476 1.683.82 2.447 2.572 2.447 4.19 0 2.21-2.09 6.667-4.667 6.667s-4.666-4.457-4.666-6.666c0-1.619.763-3.37 2.447-4.191-.684-.957-1.114-2.08-1.114-2.476 0-.645 1.145-1.183 2.667-1.307v-.026c0-.247.134-.463.333-.578",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C2E7FF",
      fillRule: "evenodd",
      d: "M16 23.333c1.19-.009 3.333-3.194 3.333-6.666 0-1.473-.825-3.334-3.333-3.334s-3.334 1.86-3.334 3.334c0 3.472 2.144 6.675 3.334 6.666",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagSmr = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagSmr_default = SvgFlagSmr;

export { FlagSmr_default as default };
